const XIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8622 10.4576L21.1468 1.92859H19.4202L13.0968 9.33397L8.04384 1.92859H2.2168L9.85669 13.128L2.2168 22.0714H3.94333L10.6221 14.2503L15.9585 22.0714H21.7856L13.8622 10.4576ZM11.4983 13.2259L10.7243 12.1108L4.56488 3.23787H7.21654L12.1861 10.3987L12.9601 11.5137L19.4217 20.8226H16.77L11.4983 13.2259Z"
      fill="currentColor"
    />
  </svg>
);

export default XIcon;
